import $http from '@/module/http';
let info = null;
let infoServiceId = null;
let cloud = null;

export default {
  strict: true,
  namespaced: true,
  state: {
    serviceInfo: {
      id: ''
    },
    clouds: {}
  },
  actions: {
    getServiceInfo: ({ commit }, { force = false, serviceId }) => {
      if (!force && info && infoServiceId === String(serviceId)) {
        return info;
      }
      infoServiceId = String(serviceId);
      const request = $http
        .get(`platform-services/${serviceId}/`)
        .then((res) => {
          // 切换 Service 后，较晚返回的旧请求不能覆盖当前详情。
          if (info === request) commit('setServiceInfo', res);
          return res;
        })
        .catch((error) => {
          if (info === request) {
            info = null;
            infoServiceId = null;
          }
          throw error;
        });
      info = request;
      return info;
    },

    getCloudList({ commit }, force = false) {
      if (!force && cloud) {
        return cloud;
      }
      cloud = $http.get('cloud_monitors/nodes_info/').then((res) => {
        commit('setClouds', res);
        return res;
      });
      return cloud;
    }
  },
  mutations: {
    setServiceInfo(state, payload) {
      state.serviceInfo = payload;
    },
    setClouds(state, payload) {
      state.clouds = payload;
    }
  }
};
